<app-header [cartCount]="productService.getLocalCartProductLength()"></app-header>

<div class="max-w-7xl mx-auto p-4 bg-gradient-to-br from-gray-50 to-white min-h-screen font-sans">
    <!-- Main Heading -->
    <!-- <div class="mt-4">
        <h2 class="text-2xl font-bold">Order Summary</h2>
        <div class="h-1 bg-gray-200 w-full mt-2 mb-6"></div>
    </div> -->
    <div class="mb-6">
        <div class="flex items-center gap-3 mb-2">
            <div
                class="w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center shadow-md">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-white" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                </svg>
            </div>
            <div>
                <h1 class="text-2xl font-bold text-gray-900">Order Summary</h1>
                <!-- <p class="text-gray-600 text-sm">Where should we send your order?</p> -->
            </div>
        </div>
        <div class="h-1 w-24 bg-gradient-to-r from-orange-500 to-orange-400 rounded-full"></div>
    </div>
    <!-- Store/Delivery Address Section -->
    <div class="bg-pink-50 border border-pink-100 rounded-lg p-2 mb-5 flex items-start gap-4">
        <div class="bg-white p-2 rounded-full shadow-sm">
            <!-- Mock for pickup_pink.png / delivery_pink.svg -->
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-pink-500" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
        </div>
        <div class="store-details">
            <h3 class="font-bold text-gray-900">Delivery At:
                {{customerDeliveryAddress?.shippingPlotNo}},{{customerDeliveryAddress?.shippingAddress}}</h3>
            <p class="text-sm text-gray-600">
                {{customerDeliveryAddress?.cityName}},{{customerDeliveryAddress?.stateName}},{{customerDeliveryAddress?.shippingPinCode}}
            </p>
        </div>
    </div>

    <!-- Delivery Group Loop -->
    <div class="mb-10" *ngFor="let cart of groupProduct; let i = index">
        <!-- Delivery Header -->
        <div class="bg-[#f97316] text-white p-2 rounded-t-lg flex justify-between items-center">
            <h1 class="text-lg font-semibold">
                Delivery - {{ i + 1 }} <span *ngIf="cart.dateTime" class="text-sm font-normal ml-2">on 25-10-2023 Time
                    Slot: 10:00 - 12:00
                    hrs</span>
            </h1>
        </div>

        <!-- Main Content Row -->
        <div class="flex flex-col lg:flex-row border border-gray-200 rounded-b-lg overflow-hidden">

            <!-- Left Side: Product List (col-md-8) -->
            <div class="lg:w-2/3 w-full p-4 border-r border-gray-100">
                <!-- Single Product Item -->
                <div *ngFor="let product of cart.games"
                    class="flex flex-col md:flex-row gap-6 border-b border-dotted border-gray-400 last:border-0">
                    <!-- Product Image Column -->
                    <div class="md:w-1/3 flex flex-col items-center">
                        <div class="relative">
                            <!-- <img src="https://via.placeholder.com/120x100" class="rounded-md object-cover shadow-sm"
                                alt="Product" /> -->
                            <img [src]="'../../../../assets/img/' + product.product_Picture" width="120px"
                                height="100px" style="border-radius: 4px;" alt="Product Picture"
                                onerror="this.src='../../../../assets/img/defaultCake.webp';" />
                            <!-- Veg/Non-Veg Icon -->
                            <div class="absolute top-1 right-1 bg-white p-0.5 rounded-sm border border-gray-300">
                                <div class="w-3 h-3 bg-green-600 rounded-full"></div>
                            </div>
                        </div>
                        <p class="mt-2 font-medium text-center text-sm">{{ product.product_Name }}</p>
                    </div>

                    <!-- Product Details Column -->
                    <div class="md:w-2/3 text-sm">
                        <div class="flex justify-between border-b border-gray-50 py-1">
                            <span class="text-gray-500">Order Qty</span>
                            <span *ngIf="product.cartProductType == 'Product' || product.net_Sale_Price <= 0"
                                class="font-semibold">{{ product.orderQuantity }} {{ product.product_Unit}}</span>
                        </div>
                        <div *ngIf="product.taxAmount > 0"
                            class="flex justify-between border-b border-gray-50 py-1 text-green-600">
                            <span>GST</span>
                            <span>{{ (product.taxAmount +
                                (product.designTaxAmount ? product.designTaxAmount : 0)) |
                                number: "1.2-2" }}</span>
                        </div>
                        <div *ngIf="product.net_Sale_Price > 0"
                            class="flex justify-between border-b border-gray-50 py-1">
                            <span>Price</span>
                            <span class="font-bold text-lg text-gray-900">{{ (product.net_Sale_Price +
                                (product.designProductNetSalePrice ?
                                product.designProductNetSalePrice : 0)) | number: "1.2-2"}}</span>
                        </div>

                        <!-- Date/Time Picker Trigger (UI from first prompt) -->
                        <!-- <div
                            class="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center justify-between cursor-pointer hover:bg-blue-100 transition-colors">
                            <div class="flex items-center gap-3">
                                <span class="text-2xl font-black text-blue-800">25</span>
                                <div class="flex flex-col leading-tight">
                                    <span class="text-xs uppercase font-bold text-blue-600">Oct</span>
                                    <span class="text-xs text-gray-600 font-medium">Wednesday</span>
                                    <span class="text-[11px] text-gray-500">10:00 AM - 12:00 PM</span>
                                </div>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-blue-600" viewBox="0 0 20 20"
                                fill="currentColor">
                                <path
                                    d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                            </svg>
                        </div> -->

                        <!-- Template for Date and Time Display -->
                        <ng-template #dateTimeDisplay>
                            <ng-container *ngIf="product.deliveryDate && product.deliveryTime; else selectPrompt">
                                <div class="flex items-center gap-3">
                                    <!-- Date and Month Column -->
                                    <div class="flex flex-col items-center leading-none">
                                        <span class="text-2xl font-bold text-gray-800" data-testid="shipping-date">
                                            {{ product.deliveryDate | date: 'dd' }}
                                        </span>
                                        <span class="text-xs font-semibold uppercase text-gray-500">
                                            {{ product.deliveryDate | date: 'MMM' }}
                                        </span>
                                    </div>

                                    <!-- Weekday and TimeSlot Column -->
                                    <div class="flex flex-col border-l pl-3 border-gray-200">
                                        <span class="text-sm font-medium text-gray-700">
                                            {{ product.deliveryDate | date: 'EEEE' }}
                                        </span>
                                        <span class="text-xs text-blue-600 font-medium">
                                            {{ convertToAmPm(product.deliveryTime) }}
                                        </span>
                                    </div>
                                </div>
                            </ng-container>

                            <ng-template #selectPrompt>
                                <span class="text-sm font-medium text-gray-400 italic">
                                    Select Delivery Date & Slot
                                </span>
                            </ng-template>
                        </ng-template>

                        <!-- Main Container -->
                        <div class="w-full max-w-sm">

                            <!-- Clickable version -->
                            <div *ngIf="product.net_Sale_Price > 0" (click)="openDeliveryTimeDialog(product)"
                                role="button"
                                class="flex items-center justify-between p-3 bg-white border border-gray-200 rounded-lg shadow-sm hover:border-blue-400 hover:bg-blue-50 transition-all cursor-pointer group">
                                <div class="flex-grow">
                                    <ng-container [ngTemplateOutlet]="dateTimeDisplay"></ng-container>
                                </div>

                                <!-- Icon Section -->
                                <div class="flex items-center justify-center ml-4">
                                    <!-- Calendar Icon (When nothing selected) -->
                                    <img *ngIf="!product.deliveryDate || !product.deliveryTime"
                                        src="../../../../assets/img/calender-icon.svg" alt="Calendar Icon"
                                        class="w-5 h-5 opacity-60 group-hover:opacity-100" />

                                    <!-- Edit Icon (When date is selected) -->
                                    <svg *ngIf="product.deliveryDate && product.deliveryTime"
                                        class="w-5 h-5 text-gray-400 group-hover:text-blue-500" fill="currentColor"
                                        viewBox="0 0 24 24">
                                        <path
                                            d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z">
                                        </path>
                                    </svg>
                                </div>
                            </div>

                            <!-- Non-clickable version -->
                            <div *ngIf="!(product.net_Sale_Price > 0 && !product.designForProductCode && !product.freeByProductCode)"
                                class="flex items-center p-3 bg-gray-50 border border-gray-100 rounded-lg opacity-80">
                                <ng-container [ngTemplateOutlet]="dateTimeDisplay"></ng-container>
                            </div>

                        </div>

                        <!-- Message Field -->
                        <form [formGroup]="mesageForm">
                            <div class="mt-4" *ngIf="product.isShowProductMessage == true">
                                <label class="text-[10px] text-gray-400 uppercase">Message/Note On Cake</label>
                                <input type="text" #input maxlength="40"
                                    (keyup)="messageInput($any($event.target).value, product)" formControlName="note"
                                    class="w-full border-b border-gray-300 focus:border-blue-500 outline-none py-1 text-sm bg-transparent">
                                <div class="text-right text-[10px] text-gray-400">0/40</div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <!-- Right Side: Summary (col-md-4) -->
            <div class="lg:w-1/3 w-full bg-gray-50">
                <div class="bg-gray-600 text-white text-center py-2 text-sm font-bold uppercase tracking-wider">
                    Summary
                </div>
                <div class="p-4">
                    <div class="flex justify-between text-sm py-1">
                        <span>Amount</span>
                        <span class="font-medium text-gray-700">{{cart.totalSaleAmt | number: "1.2-2"}}</span>
                    </div>
                    <div class="flex justify-between text-sm py-1" *ngIf="cart.totBasePremiumFlavourPrice > 0">
                        <span>Flavour Premium Price</span>
                        <span class="font-medium text-gray-700">{{cart.totBasePremiumFlavourPrice | number:
                            "1.2-2"}}</span>
                    </div>
                    <div class="flex justify-between text-sm py-1 text-green-600" *ngIf="cart.totDiscount > 0">
                        <div class="flex flex-col">
                            <span>Discount</span>
                            <span class="text-[10px]">{{cart.discountApplied}}</span>
                        </div>
                        <span class="font-medium">{{cart.totDiscount | number: "1.2-2"}}</span>
                    </div>
                    <div class="flex justify-between text-sm py-1">
                        <span>Taxable Value</span>
                        <span class="font-medium text-gray-700">{{cart.totTaxValue | number: "1.2-2"}}</span>
                    </div>
                    <div class="flex justify-between text-sm py-1" *ngIf="cart.gstAmt > 0">
                        <span>GST</span>
                        <span class="font-medium text-gray-700">{{ cart.gstAmt | number: "1.2-2" }}</span>
                    </div>
                    <div class="flex justify-between text-sm py-1" *ngIf="cart.cessAmt > 0">
                        <span>CESS</span>
                        <span class="font-medium text-gray-700">{{ cart.cessAmt | number: "1.2-2" }}</span>
                    </div>

                    <div class="flex justify-between text-sm py-1">
                        <span>Net Amount</span>
                        <span class="font-medium text-gray-700">{{cart.netAmountBeforeRoundedOff | number:
                            "1.2-2"}}</span>
                    </div>
                    <div class="flex justify-between text-sm py-1 border-t border-gray-200 pt-2"
                        *ngIf="cart.deliveryCharge == 0">
                        <span>Shipping Charges</span>
                        <span class="text-green-600 font-bold italic text-xs">FREE</span>
                    </div>

                    <div class="flex justify-between text-sm py-1" *ngIf="cart.deliveryCharge != 0">
                        <span>Shipping Charges</span>
                        <mat-icon style="height:18px;width:18px;font-size:18px;cursor:pointer;"
                            [matTooltip]="getDeliveryChargeTooltip(cart)">
                            info_outline
                        </mat-icon>
                        <span class="font-medium text-gray-700">{{cart.deliveryCharge | number: "1.2-2"}}</span>
                    </div>

                    <div class="flex justify-between text-sm py-1">
                        <span>Rounded off Amount</span>
                        <span class="font-medium text-gray-700">{{ cart.roundedOffAmount | number: "1.2-2" }}</span>
                    </div>

                    <!-- Action Button -->
                    <button *ngIf="cart.totalNetAmt >= minimumOrdeSetup?.orderMinValue && isShowCheckOut"
                        (click)="onPayClick(cart)"
                        class="w-full bg-[#13b8aa] hover:bg-[#0f9d91] text-white py-3 rounded-md font-bold text-lg shadow-lg transform active:scale-95 transition-all mt-4">
                        Pay ₹ {{ cart.grandTotal | number: "1.2-2" }}
                    </button>
                    <button *ngIf="cart.totalNetAmt < minimumOrdeSetup?.orderMinValue && isShowCheckOut"
                        class="w-full bg-[#13b8aa] hover:bg-[#0f9d91] text-white py-3 rounded-md font-bold text-lg shadow-lg transform active:scale-95 transition-all mt-4">
                        Add ₹ {{ minimumOrdeSetup?.orderMinValue - cart.totalNetAmt | number: '1.2-2' }} more to
                        CheckOut
                    </button>
                    <a *ngIf="!isShowCheckOut" class="btn2 btn-danger btn-check-out1" id="wait_btn">
                        Please wait working on offer...</a>
                </div>
            </div>
        </div>
    </div>

    <!-- Terms and Footer Pay -->
    <div *ngIf="allCartTotal" class="flex flex-col md:flex-row justify-between items-center gap-6">
        <label class="flex items-center gap-3 cursor-pointer group" [ngClass]="isAnimate ? 'label1' : 'label2'">
            <input type="checkbox" [(ngModel)]="isAgreedTerms"
                class="w-5 h-5 rounded border-gray-300 text-red-500 focus:ring-red-500">
            <span class="text-sm text-gray-600">I agree to the <button class="text-blue-600 underline">terms and
                    conditions</button></span>
        </label>

        <div class="flex items-center group">
            <button class="bg-[#d0324b] text-white flex items-center" (click)="onPayClick(groupProduct)">
                <div class="px-8 py-3 text-center border-r border-red-400">
                    <span class="text-xs uppercase block opacity-80">Final Total</span>
                    <strong class="text-xl">{{ allCartTotal | number: "1.2-2" }}</strong>
                </div>
                <div class="px-6 py-3 font-bold hover:bg-red-700 transition-colors uppercase text-sm">
                    PAY NOW
                </div>
            </button>
        </div>
    </div>
</div>